<div [copoScroller]="{restoreAfterViewInit: false}" #scroller="copoScroller" class="sidenav-content" @routeAnimation>

	<ng-template #loading>
		<copo-loading-spinner *ngIf="!isError"></copo-loading-spinner>
	</ng-template>

	<ng-container *ngIf="!isLoading && !isError && offer else loading">
		<!-- Title -->
		<div class="card-title-block copo-offer-wizard-navigation-bar">
			<button class="copo-offer-back-icon" type="button" mat-icon-button (click)="goBack()">
				<mat-icon svgIcon="md:chevron_left"></mat-icon>
			</button>
			<div class="card-title-subblock">
				<div class="card-title-label margin-r32" translate>eoffer.offer.card</div>
					<div *ngIf="offer && offer.header && offer.header.rfqRef" class="card-title-label margin-r32">{{offer.header.rfqRef}}</div>
					<div *ngIf="offer && offer.header && offer.header.referenceAm" class="card-title-label margin-r32">{{offer.header.referenceAm}}</div>
			</div>

			<div *ngIf="offer && (isDraft || isAccepted)" class="buttons-group">
				<!-- Buttons to continue draft or copy accepted offer-->
				<button
					*ngIf="offer && isDraft"
					type="button" mat-raised-button
					[disabled]="!hasUserSubmitterRole"
					(click)="evtContinueDraft()"
					class="primary-action-gray group-button"
					copoFocusMe
				>
					<mat-icon svgIcon="md:edit"></mat-icon>
					<span translate>eoffer.continue.draft</span>
				</button>
				<button
					*ngIf="offer && isAccepted"
					type="button" mat-raised-button
					[disabled]="!hasUserSubmitterRole"
					(click)="evtCopyOffer()"
					class="primary-action-gray group-button"
					copoFocusMe
				>
					<mat-icon svgIcon="fileCopy"></mat-icon>
					<span translate>eoffer.request.new.offer.from.draft</span>
				</button>
			</div>
		</div>

		<div copoAfterViewInit (afterviewinit)="scroller.restoreState()">
			<div class="copo-container">
				<!-- Offer Header -->
				<ng-container *ngIf="offer && offerBocs">
					<copo-offer-offer-header-card-block
					[header]="offer.header"
					[bocs]="offerBocs"
					[offers]="offer"
				></copo-offer-offer-header-card-block>
				</ng-container>
			</div>

			<!-- Products by family -->
			<ng-container *ngFor="let familyOfProducts of productsFamilies">
				<div class="family-header copo-dark-theme">
					<div class="family-label">{{familyOfProducts.productFamilyCategory}} {{familyOfProducts.form}}</div>
					<div class="period-label" *ngFor="let volumeObj of familyOfProducts.volumeList">
						<div *ngIf="volumeObj.pcpType === 'M' else period;"> {{volumeObj.startDate| date : "MMM yyyy"}}</div>
						<ng-template #period>
							<div>{{volumeObj.pcpType}} {{volumeObj.pcpValue}} - {{volumeObj.startDate| date : "yyyy"}}</div>
						</ng-template>
						<div>{{volumeObj.quantity ? volumeObj.quantity : 0}}t</div>
					&nbsp;</div>
					<div class="quantity-label">{{familyOfProducts.quantity}}&nbsp;t<div translate>eoffer.total.quantity.for.period.draft</div></div>
				</div>
				<div class="copo-container offer-product-margin-bottom">
					<copo-offer-offer-product-card
						[offer]="offer"
						[offerProducts]="familyOfProducts.products"
					></copo-offer-offer-product-card>
				</div>
			</ng-container>
		</div>

	</ng-container>
</div>
